import { Text, View } from '@react-pdf/renderer';
import { styles } from './pdfStyles';
import { MarketTrendsColumn, MarketTrendsTextHeader } from './MarketTrendsComponents';
import type { CustomerAnalyticsMoodysConstructionAbsorptionDetailDto } from '@zg-rentals/ts-customer-analytics-client';
import { getRowStyle } from './pdfImageUtils';

const constructionWidthPercent = 14.28;
interface ConstructionAbsorptionTableProps {
  header: string;
  leftReportName: string;
  rightReportName: string;
  leftReports: Array<CustomerAnalyticsMoodysConstructionAbsorptionDetailDto>;
  rightReports: Array<CustomerAnalyticsMoodysConstructionAbsorptionDetailDto>;
}

const getReportDateStr = (report: CustomerAnalyticsMoodysConstructionAbsorptionDetailDto) => {
  const leftReportDate = report.endingDate;
  return `Ending ${leftReportDate.month}/${leftReportDate.day}/${leftReportDate.year}`;
};

export const ConstructionAbsorptionTable = ({
  header,
  leftReportName,
  rightReportName,
  leftReports,
  rightReports,
}: ConstructionAbsorptionTableProps) => {
  const leftReportDateStr = getReportDateStr(leftReports[0]);
  const righReportDateStr = getReportDateStr(rightReports[0]);
  return (
    <>
      <MarketTrendsTextHeader headerText={header} paddingBottom={20} paddingTop={20} />
      <View style={styles.table}>
        <View style={styles.tableHeader}>
          <MarketTrendsColumn width={constructionWidthPercent} />
          <MarketTrendsColumn width={constructionWidthPercent * 3} textAlign="center">
            <Text>{leftReportName}</Text>
          </MarketTrendsColumn>
          <MarketTrendsColumn width={constructionWidthPercent * 3} textAlign="center">
            <Text>{rightReportName}</Text>
          </MarketTrendsColumn>
        </View>
        <View style={styles.tableHeader}>
          <MarketTrendsColumn width={constructionWidthPercent} />
          <MarketTrendsColumn width={constructionWidthPercent}>
            <Text>Units Built</Text>
            <Text style={styles.tableSubHeading}>{leftReportDateStr}</Text>
          </MarketTrendsColumn>
          <MarketTrendsColumn width={constructionWidthPercent}>
            <Text>Units Absorbed</Text>
            <Text style={styles.tableSubHeading}>{leftReportDateStr}</Text>
          </MarketTrendsColumn>
          <MarketTrendsColumn width={constructionWidthPercent}>
            <Text>Con/Abs Ratio</Text>
            <Text style={styles.tableSubHeading}>{leftReportDateStr}</Text>
          </MarketTrendsColumn>
          <MarketTrendsColumn width={constructionWidthPercent}>
            <Text>Units Built</Text>
            <Text style={styles.tableSubHeading}>{righReportDateStr}</Text>
          </MarketTrendsColumn>
          <MarketTrendsColumn width={constructionWidthPercent}>
            <Text>Units Absorbed</Text>
            <Text style={styles.tableSubHeading}>{righReportDateStr}</Text>
          </MarketTrendsColumn>
          <MarketTrendsColumn width={constructionWidthPercent}>
            <Text>Con/Abs Ratio</Text>
            <Text style={styles.tableSubHeading}>{righReportDateStr}</Text>
          </MarketTrendsColumn>
        </View>
        {leftReports.map((historyData, i) => (
          <View style={getRowStyle(i)} key={historyData.areaName}>
            <MarketTrendsColumn width={constructionWidthPercent} textAlign="left">
              <Text> {historyData.areaName}</Text>
            </MarketTrendsColumn>
            <DataCells report={historyData} />
            <DataCells report={rightReports[i]} />
          </View>
        ))}
      </View>
    </>
  );
};

const DataCells = ({ report }: { report: CustomerAnalyticsMoodysConstructionAbsorptionDetailDto }) => {
  return (
    <>
      <MarketTrendsColumn width={constructionWidthPercent}>
        <Text> {report.unitsBuilt.toLocaleString()}</Text>
      </MarketTrendsColumn>
      <MarketTrendsColumn width={constructionWidthPercent}>
        <Text>{report.unitsAbsorbed.toLocaleString()}</Text>
      </MarketTrendsColumn>
      <MarketTrendsColumn width={constructionWidthPercent}>
        <Text>{report.constructionAbsorptionRatio.toFixed(2)}</Text>
      </MarketTrendsColumn>
    </>
  );
};
